import React, { useEffect, useState } from "react";
import { Table, Tag } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CurrencyFormatter from "../../../components/CurrencyFormatter";
import { getSubscriptionsHistory } from "../../../network/network";
import { handleApiError } from "../../../utils/errorHandler";
import { getTableRowNumber } from "../../../utils/tablePagination";

const SubscriptionsTable = () => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState({
    current_page: 1,
    per_page: 10,
    total: 0,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setPerPageSize] = useState(10);

  useEffect(() => {
    setLoading(true);

    getSubscriptionsHistory({
      page: currentPage,
      per_page: perPageSize,
    })
      .then((response) => {
        if (response?.data?.success === false) {
          handleApiError(response, t);
          return;
        }

        const history = response.data.data?.history || [];
        const pagination = response.data.data?.pagination || {};

        setData(history);
        setPaginationData((prev) => ({
          ...prev,
          ...pagination,
        }));
      })
      .catch((error) => handleApiError(error, t))
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, perPageSize, t]);

  const handlePagination = (pagination) => {
    setCurrentPage(pagination.current);
    setPerPageSize(pagination.pageSize);
  };

  const toSentenceCase = (str) => {
    if (!str) return "";
    const lower = str.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  const tableColumns = [
    {
      title: "#",
      key: "index",
      className: "app-table-index-column",
      render: (text, record, index) => getTableRowNumber(index, paginationData),
    },
    {
      title: t("name"),
      dataIndex: "name",
      render: (name, row) => {
        const isTrial =
          row.is_trial === 1 || row.is_trial === "1" || row.is_trial === true;

        return (
          <>
            {name}{" "}
            {isTrial && (
              <Tag color="blue" style={{ marginLeft: 6 }}>
                {t("trial")}
              </Tag>
            )}
          </>
        );
      },
    },
    {
      title: t("price"),
      render: (row) => (
        <>
          <CurrencyFormatter value={row.unit_price} /> /{" "}
          {row.quantity ? t("per_user") : t("unlimited")}
        </>
      ),
    },
    {
      title: t("type"),
      dataIndex: "subscription_addon_type",
    },
    {
      title: t("start_date"),
      dataIndex: "start_date",
      render: (val) => (val ? moment(val).format("MMM. D, YYYY") : "-"),
    },
    {
      title: t("end_date"),
      dataIndex: "end_date",
      render: (val) => (val ? moment(val).format("MMM. D, YYYY") : "-"),
    },
    {
      title: t("action"),
      width: 150,
      dataIndex: "action_type",
      render: (action_type) => {
        if (!action_type) return "-";

        const color =
          action_type.toLowerCase() === "subscribed" ? "green" : "red";

        return <Tag color={color}>{toSentenceCase(action_type)}</Tag>;
      },
    },
  ];

  return (
    <Table
      columns={tableColumns}
      dataSource={data}
      loading={loading}
      rowKey="id"
      pagination={{
        current: paginationData.current_page,
        pageSize: paginationData.per_page,
        total: paginationData.total,
        showSizeChanger: true,
      }}
      onChange={handlePagination}
    />
  );
};

export default SubscriptionsTable;
